import React from 'react';
import { Profile } from '../../../components/Profile/View';
import { useAuth } from '../../../providers/AuthProvider';
import { useMutation } from '@apollo/client';
import { LOG_OUT } from '../../../graphql/mutations/mutations';
import { App, Button, Space } from 'antd';
import { useNavigate } from 'react-router';
import { ContractorInfoCard } from '../../../components/Contractor/ContractorInfoCard';

export const ProfileViewPage: React.FC = () => {
  const { message } = App.useApp();
  const { user, removeAuthUser } = useAuth();
  const navigate = useNavigate();

  const [logout] = useMutation(LOG_OUT, {
    onCompleted: data => {
      if (data?.LogOut) {
        removeAuthUser();
        message.success('Logged out successfully');
        navigate('/login');
      }
    },
    onError: error => {
      message.error(error.message || 'Logout failed');
    },
  });

  if (!user) {
    return null;
  }

  const isContractor = user.roles?.includes('CONTRACTOR');

  return (
    <Space direction="vertical" style={{ width: '100%', margin: '1em' }}>
      <Profile user={user} />
      {isContractor && (
        <ContractorInfoCard
          contractor={user.contractor}
          isContractorUser
          showEditAction
          onEdit={() =>
            navigate(user.contractor ? '/contractor/edit' : '/contractor/setup', {
              replace: false,
            })
          }
        />
      )}
      <Button onClick={() => logout()}>Logout</Button>
    </Space>
  );
};
